import { OriginType } from '@/types/origin-types'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<OriginType>({
  pathCategory: 'origin_types',
})

export function useGetOriginType({
  id,
  ...options
}: UseGetDetailOptions<OriginType>) {
  const query = useGetDetail<OriginType>({
    id,
    queryKey: queryKeys.originTypes.detail({ id, filters: options.filters }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    originType: query.data,
    ...query,
  }
}

export function useGetOriginTypes({
  filters,
  ...options
}: UseGetListOptions<OriginType> = {}) {
  const query = useGetList<OriginType>({
    filters,
    queryKey: queryKeys.originTypes.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    originTypes: query.allData,
    ...query,
  }
}
